export default __webpack_public_path__ + "static/media/loginImg.6d19acd4.png";